import { t } from '../theme';
import { useStore } from '../store';

export function Toast() {
  const toast = useStore((s) => s.toast);
  if (!toast) return null;

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 34,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '18px 30px',
        borderRadius: 999,
        background: 'oklch(0.3 0.012 60 / 0.94)',
        backdropFilter: 'blur(14px)',
        border: t.hairline,
        fontSize: 21,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        animation: 'rise 180ms ease-out',
        pointerEvents: 'none',
      }}
    >
      {toast}
    </div>
  );
}
